import AuthService from "@forwardflow/services/AuthService";
import { Button, TextField } from "@forwardflow/ui";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type SetNewPasswordFormProps = {
  onSubmit: (values: any) => void;
};

export const SetNewPasswordForm: React.FC<SetNewPasswordFormProps> = ({
  onSubmit,
}) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();

  const handleSubmit = async () => {
    const token = searchParams.get("token");
    if (token === null) return;
    try {
      setLoading(true);
      const values = await form.validateFields();
      if (values.password !== values.confirmPassword) {
        form.setFields([
          {
            name: "confirmPassword",
            errors: ["Passwords do not match"],
          },
        ]);
        return;
      }
      // const redirectUrl = "https://dashboard.forward-flow.com/set-new-password"
      const redirectUrl = `${window.location.origin}/set-new-password`

      await AuthService.apiResetPassword(token, values.password, redirectUrl);
      onSubmit(values);
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSubmit();
  }, [searchParams]);

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        initialValues={{}}
        onFinish={handleSubmit}
        className="w-full text-left text-white max-w-[450px]"
        autoComplete="off"
      >
        <TextField
          name="password"
          label="Password"
          type="password"
          formItemClassName="w-full ff-white-label"
          placeholder="Enter new password"
          isRequired
          validatePassword
          errorMessage="Please enter new password"
        />
        <TextField
          name="confirmPassword"
          type="password"
          label="Confirm Password"
          formItemClassName="w-full ff-white-label"
          placeholder="Confirm new password"
          isRequired
          validatePassword
          errorMessage="Passwords do not match"
          dependencies={"password"}
        />
        <Button isLoading={isLoading} type="submit" className="mb-10 h-[60px]">
          Reset Password
        </Button>
      </Form>
    </>
  );
};
